import { styled } from '@ori-ui/mui';

export const Highlight = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  padding: theme.spacing(6, 3),
  backgroundColor: theme.palette.grey[100],
  marginBottom: theme.spacing(6),
}));
